<template>
  <div class="role box">
    <div class="left-box">
      <div class="head-box">
        <h4>角色管理</h4>
        <!-- <div>
          <i class="el-icon-circle-plus-outline c-pointer h-primary" @click="addRole()"></i>
          <i class="el-icon-edit c-pointer c-m-l-15 h-primary" @click="editRole()"></i>
          <i class="el-icon-delete c-pointer c-m-l-15 h-danger" @click="removeRole()"></i>
        </div> -->
      </div>
      <div class="filter">
        <!-- <el-select
          v-model="searchFilter"
          placeholder="筛选组织"
          clearable
          class="w-1"
          @change="filterOrgType"
        >
          <el-option
            v-for="item in options.orgType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select> -->
        <el-input
          placeholder="请输入角色名称"
          v-model="searchRolesName"
          clearable
          style="margin-top: 10px"
          @clear="getRoles()"
          @keyup.enter.native="getRoles()"
        ></el-input>
      </div>      
      <div class="left-content row">
        <div class="content-group">
          <div
            v-for="(item, i) in roles"
            :key="i"
            class="content-item"
            :class="activeRole._id == item._id ? 'is-selected' : ''"
            @click="roleClick(item)"
          >
            <el-checkbox-group v-model="checkRoleIds">
              <el-checkbox :label="item._id">
                {{ item.name }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    <div class="right-box func-tree c-p-10">
      <!-- <div>
            <el-button
                class="tab-button"
                type="primary"
                @click.native="
                editMenu = {};
                menuDialog = true;
                "
            >
                批量添加
            </el-button>    
            <el-button
                class="tab-button"
                type="primary"
                @click.native="
                editMenu = {};
                menuDialog = true;
                "
            >
                批量删除
            </el-button> 
        </div> -->

      <!-- <div style="text-align: end;">
        <el-button type="primary" style="width:90px;" @click="1" class="c-m-l-10">批量添加</el-button>
        <el-button type="primary" style="width:90px;" @click="1" class="c-m-l-10">批量删除</el-button>
      </div> -->

      <el-tabs v-model="activeTab" @tab-click="handleClick">
        <!-- <el-tab-pane label="数据权限" name="dataAuth">
          <div>
            <div class="f-s-14 m-10">
              请设置该角色的数据权限（包括：读取、修改、删除)
            </div>
            <el-radio-group v-model="activeRole.dataAuth">
              <el-radio :label="1" border>本人</el-radio>
              <el-radio :label="2" border>本部门</el-radio>
              <el-radio :label="3" border>本部门及下级部门</el-radio>
              <el-radio :label="4" border>全部</el-radio>
            </el-radio-group>
            <el-button
              type="success"
              class="m-10 m-t-20 w-200"
              @click="saveRole('setDataAuth', true)"
            >
              保存
            </el-button>
          </div>
        </el-tab-pane> -->
        <el-tab-pane label="租户菜单" name="funcAuth">
          <el-tree
            :data="treeData"
            v-model="functionList"
            default-expand-all
            :expand-on-click-node="false"
            :indent="50"
            node-key="_id"
            ref="tree"
            :props="defaultProps"
            style="height: auto;"
          >
            <span
              :class="data.type == 'button' ? 'buttons' : ''"
              class="custom-tree-node c-w-1"
              style="overflow: auto;"
              slot-scope="{ node, data }"
            >
              <div>
                <i :class="data.icon ? 'm-r-5 ' + data.icon : ''"></i>
                <span
                  :class="data.icon ? 'f-w-500' : ''"
                  style="display: flex;flex-wrap: wrap;width: 100%;"
                >
                  <span class="m-r-20" style="margin-top: 2px;margin-bottom: 2px;">
                    <span v-if="!data.color">{{ data.name }}</span>
                    <el-tag
                      v-else
                      effect="dark"
                      :color="data.color"
                      style="border:none;margin-top: 2px;margin-bottom: 2px;"
                    >
                      {{ data.name }}
                    </el-tag>
                  </span>
                  <el-checkbox
                    class="m-r-20"
                    style="margin-top: 2px;margin-bottom: 2px;"
                    v-for="(item, i) in data.buttonList"
                    :key="i"
                    v-model="buttonIds"
                    :label="item._id"
                    border
                    size="mini"
                  >
                    {{ item.label }}
                  </el-checkbox>
                </span>
              </div>
            </span>
          </el-tree>
          <el-button type="success" class="m-10 m-t-20 w-200" @click="saveFunAuth()">
            保存设置
          </el-button>
        </el-tab-pane>
        <!-- 批量操作页面 -->
        <el-tab-pane label="批量操作" name="funcAllAuth">
          <el-tree
            :data="treeAllData"
            v-model="functionList"
            show-checkbox
            default-expand-all
            :expand-on-click-node="false"
            :indent="50"
            node-key="_id"
            ref="tree"
            :props="defaultProps"
            style="height: auto;"
          >
            <span
              :class="data.type == 'button' ? 'buttons' : ''"
              class="custom-tree-node c-w-1"
              style="overflow: auto;"
              slot-scope="{ node, data }"
            >
              <div>
                <i :class="data.icon ? 'm-r-5 ' + data.icon : ''"></i>
                <span
                  :class="data.icon ? 'f-w-500' : ''"
                  style="display: flex;flex-wrap: wrap;width: 100%;"
                >
                  <span class="m-r-20" style="margin-top: 2px;margin-bottom: 2px;">
                    <span v-if="!data.color">{{ data.name }}</span>
                    <el-tag
                      v-else
                      effect="dark"
                      :color="data.color"
                      style="border:none;margin-top: 2px;margin-bottom: 2px;"
                    >
                      {{ data.name }}
                    </el-tag>
                  </span>
                  <el-checkbox
                    class="m-r-20"
                    style="margin-top: 2px;margin-bottom: 2px;"
                    v-for="(item, i) in data.buttonList"
                    v-model="batchButtonIds"
                    :key="i"
                    :label="item._id"
                    border
                    size="mini"
                  >
                    {{ item.label }}
                  </el-checkbox>
                </span>
              </div>
            </span>
          </el-tree>
          <el-button type="success" class="m-10 m-t-20 w-200" @click="batchSave()">
            批量保存
          </el-button>
          <el-button type="success" class="m-10 m-t-20 w-200" @click="batchRemove()">
            批量删除
          </el-button>
        </el-tab-pane>
          <el-tab-pane label="业务动态" name="log">
            <div class="box-center-tool">
              <div>
                <el-date-picker
                  v-model="log.searchDate"
                  type="datetimerange"
                  style="width: 320px;"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  clearable
                  @change="getLog"
                  class="search-date"
                ></el-date-picker>
              </div>
              <div>
                <el-input
                  placeholder="请输入标题/内容"
                  v-model="log.searchValue"
                  class="search-input"
                  clearable
                  @clear="getLog"
                  @keyup.enter.native="getLog"
                >
                  <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
                </el-input>
              </div>
            </div>
            <div
              class="c-flex"
              style="justify-content: flex-end;padding: 0 10px;"
              v-if="osg.has('ServiceAppointment,patchingWorkflow')"
            >
              <el-button type="primary" @click="patchingWorkflow('patchingWorkflowFpgd')">
                补派工队节点处理
              </el-button>
              <el-button type="primary" @click="patchingWorkflow('patchingWorkflowSgxlc')">
                补施工小流程处理
              </el-button>
            </div>
            <div class="box-center-content">
              <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
                <div class="activity-card-header">
                  <span class="c-font-500">
                    <i class="el-icon-monitor c-w-30"></i>
                    {{ log.title }}
                  </span>
                  <span>{{ log.createTime }}</span>
                </div>

                <div v-if="log.extData && log.extData.length > 0" class="activity-card-content">
                  <!-- {{ log.content }} -->
                  <div class v-for="(sub, ui) in log.extData" :key="ui">
                    <div>{{ sub.name }} : {{ sub.value }}</div>
                  </div>
                </div>
                <div v-else class="activity-card-content">
                  {{ log.content || '' }}
                </div>
                <div class="activity-card-footer">
                  <span>操作人：{{ log.createUserName }}</span>
                  <span>操作类型：{{ log.opType }}</span>
                </div>
              </div>
            </div>
          </el-tab-pane>      
      </el-tabs>
    </div>
    <!-- <el-dialog title="角色信息" :visible.sync="roleDialog" width="500px">
      <el-form :model="activeRole" ref="formData" :rules="rules">
        <el-form-item label="编号" label-width="60px" prop="code">
          <el-input v-model="activeRole.code"></el-input>
        </el-form-item>
        <el-form-item label="名称" label-width="60px" prop="name">
          <el-input v-model="activeRole.name"></el-input>
        </el-form-item>
        <el-form-item label="描述" label-width="60px">
          <el-input v-model="activeRole.memo"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="saveRole()">确 定</el-button>
        <el-button @click="roleDialog = false">取 消</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>
<script>
export default {
  name: 'role',
  data() {
    return {
      type: '', //平台type=a,租户type=c
      roles: [], //左侧所有角色
      //右侧激活tab页
      activeTab: 'funcAuth',
      //角色对话框
      //   roleDialog: false,
      activeRole: {}, //当前选择角色
      //菜单树
      treeData: [],
      treeAllData: [], //所有菜单
      functionList: [],
      functionIds: [],
      buttonIds: [],
      batchFunctionIds: [], //批量操作菜单
      batchButtonIds: [], //批量操作按钮
      defaultProps: {
        children: 'functionList',
        label: 'name'
      },
      roleRules: {
        name: [{ required: true, trigger: 'blur', message: '名称不能为空' }]
      },
      rules: this.$util.rules,
      checkRoleIds: [], //角色前的勾选框
      searchRolesName:'', //搜索角色名称
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },      
    };
  },
  mounted() {
    this.doInit();
    this.getAllTree();
  },
  methods: {
    doInit() {
      window.$this = this;
      this.type = this.osg.param('type');
      this.getRoles();
    },
    //标签页切换
    // handleClick(tab, event) {
    //   if (tab.index == '0') {
    //     this.getTree(this.rolesId);
    //   }
    // },
    handleClick(tab) {
      switch (tab.name) {
        case 'funcAuth':
          this.getTree(this.rolesId);
          break;
        case 'log':
          this.getLog();
          break;        
        default:
          return;
      }
    },
    //获取所有角色
    getRoles() {
      this.osg.ajax(
        'role/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'in:type|array#and': this.type,
          type: 'cc',
          notFilterTenantId: '1',
          'nin:_id|array#and': '0',
          'regex:name|string#or': this.searchRolesName,        
          sortField: 'createTime',
          sortOrder: 'desc',         
        },
        res => {
          this.roles = res.data;
        }
      );
    },
    //选择角色
    roleClick(item) {
      this.activeRole = this.$util.deepCopy(item);
      this.buttonIds = this.activeRole.buttonIds; //按钮
      this.functionIds = this.activeRole.functionIds; //菜单
      this.rolesId = item._id;
      this.getTree(item._id);
    },
    //新增角色
    // addRole() {
    //   this.activeRole = {};
    //   this.roleDialog = true;
    // },
    //保存角色
    saveRole(setDataAuth, isValidate) {
      if (setDataAuth == 'setDataAuth' && !this.activeRole._id) {
        this.osg.toast('请先选择要设置的角色！', 'warning');
        return;
      }
      if (!isValidate) {
        if (!this.osg.validate()) {
          return;
        }
      }
      var activeRole = this.activeRole;
      activeRole.type = activeRole.type || this.type; //类型a:平台 b:租户
      activeRole.order = activeRole.order || this.roles.length + 1; //排序
      activeRole.dataAuth = activeRole.dataAuth || 1; //自身数据权限 || 默认数据权限
      activeRole.checkedFunctionIds = JSON.stringify(this.checkedFunctionIds || []); //全选中的菜单id数组字符串
      activeRole.functionIds = this.functionIds.join(); //所有选中的菜单id数组
      activeRole.buttonIds = this.buttonIds.join(); //按钮id数组
      this.osg.ajax('role/upsert.do', activeRole, res => {
        this.osg.toast('保存成功！');
        this.roleDialog = false;
        this.getRoles();
      });
    },
    //新增/编辑角色
    // editRole() {
    //   if (!this.activeRole) {
    //     this.osg.toast('请选择要编辑的角色！', 'warning');
    //   } else {
    //     this.roleDialog = true;
    //   }
    // },
    //删除角色
    // removeRole() {
    //   if (!this.activeRole) {
    //     this.osg.toast('请选择要删除的角色！', 'warning');
    //   } else {
    //     this.osg.confirm(`是否确认删除角色"${this.activeRole.name}"`, () => {
    //       this.osg.ajax(`role/remove/${this.activeRole._id}.do`, {}, res => {
    //         this.osg.toast('删除成功！');
    //         this.getRoles();
    //       });
    //     });
    //   }
    // },
    //获取菜单和按钮
    getTree(_id) {
      this.osg.ajax('function/queryTenantTree.do', { tenantId: _id }, res => {
        this.treeData = res.data.functionList;
        //勾选树组件
        this.$refs.tree.setCheckedKeys(JSON.parse(this.activeRole.checkedFunctionIds || '[]'));
      });
    },
    //获取全部菜单
    getAllTree() {
      this.osg.ajax('function/queryTree.do', { type: 'c' }, res => {
        this.treeAllData = res.data.functionList;
        //勾选树组件
        this.$refs.tree.setCheckedKeys(JSON.parse(this.activeRole.checkedFunctionIds || '[]'));
      });
    },
    //保存功能权限
    saveFunAuth() {
      if (!this.activeRole) {
        this.osg.toast('请先选择要设置的角色！', 'warning');
        return;
      }
      this.checkedFunctionIds = this.$refs.tree.getCheckedKeys(true);
      this.functionIds = this.$refs.tree
        .getCheckedKeys()
        .concat(this.$refs.tree.getHalfCheckedKeys());
      this.saveRole(true, true);
    },
    // 批量保存
    batchSave() {
      if (this.checkRoleIds == '') {
        this.osg.toast('请先勾选要设置的角色！', 'warning');
        return;
      }
      this.checkedFunctionIds = this.$refs.tree.getCheckedKeys(true);

      this.batchFunctionIds = this.$refs.tree
        .getCheckedKeys()
        .concat(this.$refs.tree.getHalfCheckedKeys());
      this.authorize();
      this.batchFunctionIds = [];
      this.$refs.tree.setCheckedKeys([]);
      this.batchButtonIds = [];
    },
    // 批量删除
    batchRemove() {
      if (!this.checkRoleIds) {
        this.osg.toast('请先勾选要设置的角色！', 'warning');
        return;
      }
      this.checkedFunctionIds = this.$refs.tree.getCheckedKeys(true);
      this.batchFunctionIds = this.$refs.tree
        .getCheckedKeys()
        .concat(this.$refs.tree.getHalfCheckedKeys());
      this.revoke();
      this.batchFunctionIds = [];
      this.$refs.tree.setCheckedKeys([]);
      this.batchButtonIds = [];
    },
    //批量授权
    authorize() {
      let params = {
        roleIds: this.checkRoleIds,
        functionIds: this.batchFunctionIds,
        buttonIds: this.batchButtonIds
      };
      this.osg.ajax('function/authorize.do', { data: JSON.stringify(params) }, res => {
        this.osg.toast('保存成功！');
        this.roleDialog = false;
        this.getRoles();
      });
    },
    // 批量撤销
    revoke() {
      let params = {
        roleIds: this.checkRoleIds,
        functionIds: this.batchFunctionIds,
        buttonIds: this.batchButtonIds
      };
      this.osg.ajax('function/revoke.do', { data: JSON.stringify(params) }, res => {
        this.osg.toast('保存成功！');
        this.roleDialog = false;
        this.getRoles();
      });
    },
    /**
     * 日志
     */
    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      if(typeof(this.rolesId)=='undefined' || this.rolesId == ''){
        this.osg.alert('请勾选角色！');
        return;
      }
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.rolesId,
          tenantId: this.rolesId,
          smodule: 'role',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
    },    
  },
  watch: {
    $route() {
      this.doInit();
    }
  }
};
</script>
<style scoped>
/* 数据权限选择按钮 */
.func-tree .el-radio-group {
  display: flex;
  flex-direction: column;
}
.func-tree .el-radio-group > label {
  width: 200px;
  margin: 10px;
}
.row .content-item {
  font-size: initial !important;
}
.el-tabs__content {
  overflow-y: auto;
}
</style>
<style>
/*菜单权限树*/
.func-tree .el-form-item__label {
  text-align: center !important;
}
.func-tree .el-tree-node__content {
  padding: 0px 10px 0px 0;
  margin: 2px 0px;
  height: auto;
}
.func-tree
  .el-tree
  > .el-tree-node
  > .el-tree-node__children
  > .is-expanded
  > .el-tree-node__children
  > .is-expanded {
  display: inline-block;
}
.func-tree
  .el-tree
  > .el-tree-node
  > .el-tree-node__children
  > .is-expanded
  > .el-tree-node__children {
  padding-left: 100px;
}
.func-tree
  .el-tree
  > .el-tree-node
  > .el-tree-node__children
  > .is-expanded
  > .el-tree-node__children
  > .is-expanded
  > .el-tree-node__content {
  padding-left: 0 !important;
  height: auto;
}
</style>
